import bem from "easy-bem";
import React from "react";
import { noop } from "utils/basic";

import { useHashHighlight } from "./hooks/useHashHighlight";
import { useOverflowDetector } from "./hooks/useOverflowDetector";

import "./SimpleCard.css";

const cn = bem("simple-card");

type SimpleCardProps = {
  headerColor?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  content: React.ReactNode;
  wrapContent?: boolean;
  scrollable?: boolean;
  style?: React.CSSProperties;
  className?: string;
  onHasOverflow?: (hasOverflow: boolean) => void;
  cardId?: string;
};

const SimpleCard: React.FC<SimpleCardProps> = ({
  header,
  footer,
  content,
  wrapContent = true,
  scrollable = false,
  headerColor,
  style,
  className,
  cardId,
  onHasOverflow = noop,
}) => {
  const isHighlighted = useHashHighlight(cardId);
  const { contentWrapperRef, contentInsideWrapperRef } = useOverflowDetector(
    content,
    onHasOverflow,
  );

  return (
    <div
      className={`${cn({ highlighted: isHighlighted })}${className ? " " + className : ""}`}
      style={style}
      id={cardId}
    >
      {header && (
        <div
          className={cn("header")}
          style={headerColor ? { backgroundColor: headerColor } : {}}
        >
          {header}
        </div>
      )}
      <div className={cn("content", { scrollable })}>
        {wrapContent ? (
          <div
            className={cn("content-wrapper", { scrollable })}
            ref={contentWrapperRef}
          >
            <div
              className={cn("content-inside-wrapper")}
              ref={contentInsideWrapperRef}
            >
              {content}
            </div>
          </div>
        ) : (
          <div className={cn("content-wrapper", { scrollable })}>{content}</div>
        )}
      </div>
      {footer && <div className={cn("footer")}>{footer}</div>}
    </div>
  );
};

export default SimpleCard;
